import {
  SET_USERS,
  ADD_USER,
  UPDATE_USER,
  REMOVE_USER,
  USERS_LOADING,
  CLEAR_USERS,
} from "../actions/types";

const initialState = {
  loading: false,
  users: [],
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case USERS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_USERS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };
    case ADD_USER:
      return {
        ...state,
        loading: false,
        users: [...state.users, action.payload],
      };
    case UPDATE_USER:
      return {
        ...state,
        loading: false,
        users: state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        ),
      };
    case REMOVE_USER:
      return {
        ...state,
        loading: false,
        users: state.users.filter((user) => user._id !== action.payload),
      };
    case CLEAR_USERS:
      return {
        ...state,
        loading: false,
        users: [],
      };
    default:
      return state;
  }
}
